import { DownOutlined, UpOutlined } from '@ant-design/icons';
import classnames from 'classnames';
import { isEmpty, isFunction } from 'lodash';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { ShowMoreButtonWrapper } from './ShowMore.style';
import { getArticleTypeInGA } from '../../common/analytics/helpers/articleTypeHelper';
import { trackArticleReadMore } from '../../common/analytics/analyticsTracker';
import { WholeState } from '../../store/common/type';
import { Post } from '../../queries/contentPage/postDetail';

interface ShowMoreProps {
  showMoreInfo?: () => void;
  showLessInfo?: () => void;
  showMoreText: string;
  showLessText?: string;
  source?: string;
  postingData?: Post;
  isBeforeShowButtonWrapper?: boolean;
  isOnSeoFooter?: boolean;
  isUsedInCommentSection?: boolean;
  isUsedInProjectPage?: boolean;
  isUsedForTag?: boolean;
  marginTop?: number;
  padding?: number;
  display?: string;
  fadeOffset?: number;
  className?: string;
}
const ShowMore: React.FC<ShowMoreProps> = ({
  showMoreInfo,
  showMoreText = '',
  showLessText = '',
  showLessInfo,
  source,
  postingData,
  isBeforeShowButtonWrapper = true,
  isOnSeoFooter = false,
  isUsedInCommentSection = false,
  isUsedInProjectPage = false,
  isUsedForTag = false,
  marginTop = 20,
  padding = 0,
  display = 'block',
  fadeOffset = -60,
}) => {
  const [expanded, setExpanded] = useState(false);
  const [toggleText, setToggleText] = useState(showMoreText);
  const [toggleArrow, setToggleArrow] = useState('down');
  const { postCategory, videoType } = postingData || {};
  const articleTypeInGA = getArticleTypeInGA(postCategory, videoType);
  const userInfo = useSelector((state: WholeState) =>
    state.common !== undefined ? state.common.user : {},
  );

  const toggleShowMore = () => {
    if (toggleArrow === 'down') {
      if (isFunction(showMoreInfo)) {
        showMoreInfo();
      }
      setExpanded(!expanded);
      setToggleText(showMoreText);
      setToggleArrow('up');
    } else {
      if (isFunction(showLessInfo)) {
        showLessInfo();
      }
      setExpanded(!expanded);
      setToggleText(showLessText);
      setToggleArrow('down');
    }
  };

  const onShowMoreClick = () => {
    toggleShowMore();

    if (!isUsedInProjectPage && !isOnSeoFooter && !isEmpty(source)) {
      const { project } = postingData;
      trackArticleReadMore(
        userInfo,
        {
          ...postingData,
          articleTypeInGA,
          id: 0,
          title: '',
          tags: [],
        },
        project,
        source,
      );
    }
  };

  return (
    <ShowMoreButtonWrapper
      className="show-more-button"
      data-test={'show-more-button'}
      isBeforeShowButtonWrapper={isBeforeShowButtonWrapper}
      isOnSeoFooter={isOnSeoFooter}
      isUsedInCommentSection={isUsedInCommentSection}
      isUsedInProjectPage={isUsedInProjectPage}
      isUsedForTag={isUsedForTag}
      marginTop={marginTop}
      padding={padding}
      display={display}
      fadeOffset={fadeOffset}
    >
      <a onClick={() => onShowMoreClick()} className={classnames({ expanded })}>
        {toggleText}
        {toggleArrow === 'up' && <UpOutlined />}
        {toggleArrow === 'down' && <DownOutlined />}
      </a>
    </ShowMoreButtonWrapper>
  );
};

export default ShowMore;
